const lockedFieldConfig = {
  disabled: true,
  inputClassName: "!bg-white !text-gray-400 !border-gray-400",
};

const disableForInvoice = ({
  invoice,
  hasPermission,
  permission,
  extraCondition = false,
  lockWhenExported = true,
}) =>
  (lockWhenExported && invoice?.isExported) ||
  extraCondition ||
  !hasPermission(permission)
    ? lockedFieldConfig
    : {};

export { disableForInvoice, lockedFieldConfig };
